const Pictures = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0833 5.83333C10.9327 5.83333 10 6.76607 10 7.91667C10 9.06726 10.9327 10 12.0833 10C13.2339 10 14.1667 9.06726 14.1667 7.91667C14.1667 6.76607 13.2339 5.83333 12.0833 5.83333Z"
      fill="#D0D0D4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 4.79167C2.5 3.52601 3.52601 2.5 4.79167 2.5H15.2083C16.474 2.5 17.5 3.52601 17.5 4.79167V15.2083C17.5 16.474 16.474 17.5 15.2083 17.5H4.79167C3.52601 17.5 2.5 16.474 2.5 15.2083V4.79167ZM3.75 12.0328L5.04621 10.7366C5.94116 9.84162 7.39217 9.84162 8.28712 10.7366L13.8005 16.25H15.2083C15.7836 16.25 16.25 15.7836 16.25 15.2083V4.79167C16.25 4.21637 15.7836 3.75 15.2083 3.75H4.79167C4.21637 3.75 3.75 4.21637 3.75 4.79167V12.0328Z"
      fill="#D0D0D4"
    />
  </svg>
)

export default Pictures
